import {AppAnswer, AppParty, AppPreset, AppQuestion, AppQuestionGroup, AppView, AppViewQuestion} from "../types/types";

export interface IFindable {
    findByName: (name: string) => (AppScriptQuestion | AppScriptViewQuestion |  AppScriptQuestionGroup);
    findById: (id: number) => (AppScriptQuestion | AppScriptViewQuestion |  AppScriptQuestionGroup);
}

export interface IHideable {
    hide: (value: boolean) => void;
}

export interface IDisableable {
    disable: (value: boolean) => void;
}

export interface AppScriptParty extends AppParty, IFindable {
    presets: AppScriptPreset[];
}

export interface CommonAppScriptQuestion extends IDisableable, IHideable {
    getAnswers: () => AppAnswer[];
    setAnswer: (answer: SetAnswerType) => void;
    clear: () => void;
    on: (event: "changed", callback: (e: any) => void) => void;
}

export interface AppScriptQuestion extends AppQuestion, CommonAppScriptQuestion {
}

export interface AppScriptViewQuestion extends AppViewQuestion, CommonAppScriptQuestion {
}

export interface AppScriptPreset extends AppPreset, IFindable {
    items: Array<AppScriptQuestion | AppScriptQuestionGroup>;
}

export interface AppScriptQuestionGroup extends AppQuestionGroup, IFindable, IDisableable, IHideable {
    views: AppScriptViewArray;
}

interface AppScriptViewArray extends Array<AppScriptView> {
    delete: (views: AppScriptView | AppScriptView[]) => void;
}

export interface AppScriptView extends AppView, IFindable {
    questions: AppScriptViewQuestion[];
    clear: () => void;
}

export const IsQuestionGroup = (question: AppScriptQuestionGroup | AppScriptQuestion): question is AppScriptQuestionGroup => {
    return (question as AppScriptQuestionGroup).views !== undefined;
}

export type SetAnswerType = string | string[] | { id: string } | { id: string }[];

export interface Application {
    party: AppScriptParty;
}

declare global {
    interface Window {
        party: AppScriptParty;
        App: Application;
        copyParty: AppScriptParty;
    }
}